import { Text, type TextProps } from '@mantine/core';
import { Link } from 'react-router-dom';
import { splitAppointmentDisplayTitle } from './buildAppointmentDisplayTitle';

export interface AppointmentTitleTextProps extends TextProps {
  title: string;
  clientDisplayName?: string | null;
  clientChartHref?: string;
}

/** `{Client} — {Episode}` with the client name linking to the chart when an href is set. */
export function AppointmentTitleText({
  title,
  clientDisplayName,
  clientChartHref,
  ...textProps
}: AppointmentTitleTextProps): JSX.Element {
  const { clientName, rest } = splitAppointmentDisplayTitle(title, clientDisplayName);
  const linked = Boolean(clientChartHref && clientName);

  return (
    <Text {...textProps}>
      {linked ? (
        <>
          <Text
            component={Link}
            to={clientChartHref as string}
            span
            inherit
            c="gold.7"
            style={{ textDecoration: 'none' }}
          >
            {clientName}
          </Text>
          {rest ? ` — ${rest}` : null}
        </>
      ) : (
        title
      )}
    </Text>
  );
}
